import React, { useRef, useState, useEffect } from 'react';

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

var fileToArray = function (url) {
    return new Promise(function (resolve, reject) {
        try {
            var request_1 = new XMLHttpRequest();
            request_1.open('GET', url, true);
            request_1.responseType = 'blob';
            request_1.onload = function () {
                var reader = new FileReader();
                reader.readAsArrayBuffer(request_1.response);
                reader.onloadend = function () {
                    resolve(reader.result);
                };
            };
            request_1.send();
        }
        catch (_a) {
            reject("error while retrieving file " + url + ".");
        }
    });
};
var reloadIFrame = function (iframe) {
    if (iframe) {
        console.log('reloading..');
        // eslint-disable-next-line no-self-assign
        iframe.src = iframe.src;
    }
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
var handleFileUpload = function (fileInput) {
    return new Promise(function (resolve, reject) {
        if (fileInput.target.files && fileInput.target.files[0]) {
            var reader = new FileReader();
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            reader.onload = function (e) {
                resolve(e.target.result);
            };
            reader.readAsDataURL(fileInput.target.files[0]);
        }
        else {
            reject('no files selected');
        }
    });
};
var getbaseUrl = function () {
    var pathArray = window.location.href.split('/');
    var protocol = pathArray[0];
    var host = pathArray[2];
    return protocol + '//' + host;
};
var getLocation = function (href) {
    var match = href.match(/^(https?\:)\/\/(([^:\/?#]*)(?:\:([0-9]+))?)([\/]{0,1}[^?#]*)(\?[^#]*|)(#.*|)$/);
    return match && {
        href: href,
        protocol: match[1],
        host: match[2],
        hostname: match[3],
        port: match[4],
        pathname: match[5],
        search: match[6],
        hash: match[7]
    };
};
var getDocxToHtml = function (url) { return __awaiter(void 0, void 0, void 0, function () {
    var arrayBuffer, resultObject;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!mammoth) {
                    console.error('Please install mammoth and make sure mammoth.browser.min.js is loaded.');
                }
                return [4 /*yield*/, fileToArray(url)];
            case 1:
                arrayBuffer = _a.sent();
                return [4 /*yield*/, mammoth.convertToHtml({ arrayBuffer: arrayBuffer })];
            case 2:
                resultObject = _a.sent();
                return [2 /*return*/, resultObject.value];
        }
    });
}); };
var googleCheckSubscription = function () {
    var subscription = null;
    var checkCount = 0;
    return {
        subscribe: function (iframe, interval, maxChecks) {
            if (interval === void 0) { interval = 3000; }
            if (maxChecks === void 0) { maxChecks = 5; }
            if (!iframeIsLoaded(iframe)) {
                subscription = setInterval(function () {
                    checkCount++;
                    if (checkCount >= maxChecks) {
                        clearInterval(subscription);
                    }
                    reloadIFrame(iframe);
                }, interval);
                return subscription;
            }
            else {
                if (subscription) {
                    clearInterval(subscription);
                }
            }
        },
        unsubscribe: function () {
            if (subscription) {
                clearInterval(subscription);
            }
        },
    };
};
var iframeIsLoaded = function (iframe) {
    var _a;
    // its #document <html><head></head><body></body></html> when google is returning a 204
    // so if contentDocument = null then it's loaded.
    var isLoaded = false;
    try {
        if (!internetExplorer()) {
            isLoaded = !(iframe === null || iframe === void 0 ? void 0 : iframe.contentDocument);
        }
        else {
            isLoaded = !((_a = iframe === null || iframe === void 0 ? void 0 : iframe.contentWindow) === null || _a === void 0 ? void 0 : _a.document);
        }
    }
    catch (_b) {
        // ignore message Blocked a frame with origin "http://..." from accessing a cross-origin frame.
    }
    return isLoaded;
};
var internetExplorer = function () {
    return (/MSIE (\d+\.\d+);/.test(navigator.userAgent) || navigator.userAgent.indexOf("Trident/") > -1);
};
var getViewerDetails = function (url, configuredViewer, queryParams, viewerUrl) {
    if (configuredViewer === void 0) { configuredViewer = 'google'; }
    if (queryParams === void 0) { queryParams = ''; }
    if (viewerUrl === void 0) { viewerUrl = ''; }
    switch (configuredViewer) {
        case 'google':
            viewerUrl = "https://docs.google.com/gview?url=%URL%&embedded=true";
            break;
        case 'office': {
            viewerUrl = "https://view.officeapps.live.com/op/embed.aspx?src=%URL%";
            break;
        }
        case 'pdf': {
            viewerUrl = '';
            break;
        }
    }
    var externalViewer = configuredViewer === 'google' ||
        configuredViewer === 'office' ||
        configuredViewer === 'url';
    var u = url.indexOf('/') ? encodeURIComponent(url) : url;
    var fullUrl = viewerUrl ? viewerUrl.replace('%URL%', u) : url;
    if (queryParams && externalViewer && configuredViewer !== 'url') {
        var start = queryParams.startsWith('&') ? '' : '&';
        fullUrl = "" + fullUrl + start + queryParams;
    }
    return {
        url: fullUrl,
        externalViewer: externalViewer,
    };
};
var replaceLocalUrl = function (url, overrideLocalhost) {
    var loc = getLocation(url);
    var locReplace = getLocation(overrideLocalhost);
    if (loc && locReplace) {
        return url.replace(loc.port ? loc.hostname + ":" + loc.port : loc.hostname, locReplace.port ? locReplace.hostname + ":" + locReplace.port : locReplace.hostname);
    }
    return url;
};
var getBlobFromUrl = function (url) {
    return new Promise(function (resolve, reject) {
        var request = new XMLHttpRequest();
        request.open('GET', url, true);
        request.responseType = 'blob';
        request.onload = function () {
            resolve(request.response);
        };
        request.onerror = reject;
        request.send();
    });
};
var uploadToCloud = function (fileUrl, api) { return new Promise(function (resolve, reject) {
    getBlobFromUrl(fileUrl).then(function (blob) {
        var _a, _b;
        var loc = getLocation(fileUrl);
        var name = (loc === null || loc === void 0 ? void 0 : loc.pathname) ? (_a = loc === null || loc === void 0 ? void 0 : loc.pathname) === null || _a === void 0 ? void 0 : _a.split('/')[((_b = loc === null || loc === void 0 ? void 0 : loc.pathname) === null || _b === void 0 ? void 0 : _b.split('/').length) - 1] : '';
        var formData = new FormData();
        var request = new XMLHttpRequest();
        formData.append('file', blob, name);
        request.onreadystatechange = function (e) {
            if (request.readyState === XMLHttpRequest.DONE) {
                if (request.status === 200) {
                    resolve(request.responseText);
                }
                else {
                    reject(request.responseText);
                }
            }
        };
        request.onerror = reject;
        request.open('post', api, true);
        request.send(formData);
    });
}); };
var isLocalFile = function (file) {
    var loc = getLocation(file);
    var hostname = (loc === null || loc === void 0 ? void 0 : loc.hostname) || '';
    return ((['localhost', '127.0.0.1', '', '::1'].includes(hostname))
        || (hostname.startsWith('192.168.'))
        || (hostname.startsWith('10.0.'))
        || (hostname.endsWith('.local')));
};

var iframeStyle = {
    width: '100%',
    height: '100%',
};
var defaultProps$1 = {
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    loaded: function () { },
    googleCheckContentLoaded: true,
    googleCheckInterval: 3000,
    queryParams: '',
    url: '',
    overrideLocalhost: '',
    googleMaxChecks: 5,
    viewer: 'google',
    viewerUrl: '',
};
var DocumentViewer = function (inputProps) {
    var _a;
    var iframeRef = useRef(null);
    var _b = useState({
        url: '',
        externalViewer: true,
        docHtml: { __html: '' },
    }), state = _b[0], setState = _b[1];
    var checkIFrameSubscription = useRef();
    var props = useRef();
    useEffect(function () {
        props.current = __assign(__assign({}, defaultProps$1), inputProps);
        // debugger;
        var details = getViewerDetails(props.current.url, props.current.viewer, props.current.queryParams, props.current.viewerUrl);
        if (details.externalViewer &&
            props.current.overrideLocalhost &&
            isLocalFile(props.current.url)) {
            var newUrl = replaceLocalUrl(props.current.url, props.current.overrideLocalhost);
            details = getViewerDetails(newUrl, props.current.viewer, props.current.queryParams, props.current.viewerUrl);
        }
        console.log(details.url);
        setState({
            url: details.url,
            externalViewer: details.externalViewer,
            docHtml: { __html: '' },
        });
        if (iframeRef && iframeRef.current) {
            var iframe = iframeRef.current;
            if (checkIFrameSubscription && checkIFrameSubscription.current) {
                checkIFrameSubscription.current.unsubscribe();
            }
            if (props.current.viewer === 'google' &&
                props.current.googleCheckContentLoaded === true) {
                reloadIframe(iframe, details.url, props.current.googleCheckInterval, props.current.googleMaxChecks);
            }
        }
        else if (props.current.viewer === 'mammoth') {
            var setHtml = function () { return __awaiter(void 0, void 0, void 0, function () {
                var docHtml;
                var _a;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            _a = {};
                            return [4 /*yield*/, getDocxToHtml(details.url)];
                        case 1:
                            docHtml = (_a.__html = _b.sent(), _a);
                            setState({
                                url: '',
                                docHtml: docHtml,
                                externalViewer: false,
                            });
                            return [2 /*return*/];
                    }
                });
            }); };
            setHtml();
        }
        return function () {
            if (checkIFrameSubscription && checkIFrameSubscription.current) {
                checkIFrameSubscription.current.unsubscribe();
            }
        };
    }, [inputProps]);
    var reloadIframe = function (iframe, url, interval, maxChecks) {
        checkIFrameSubscription.current = googleCheckSubscription();
        checkIFrameSubscription.current.subscribe(iframe, interval, maxChecks);
    };
    var iframeLoaded = function () {
        if (props.current &&
            iframeRef &&
            iframeRef.current !== null &&
            iframeIsLoaded(iframeRef.current)) {
            if (props.current.loaded)
                props.current.loaded();
            if (checkIFrameSubscription.current) {
                checkIFrameSubscription.current.unsubscribe();
            }
        }
    };
    return state.externalViewer ? (React.createElement("iframe", { style: iframeStyle, ref: iframeRef, onLoad: function () {
            iframeLoaded();
        }, id: "iframe", title: "iframe", frameBorder: "0", src: state.url })) : ((_a = props.current) === null || _a === void 0 ? void 0 : _a.viewer) !== 'pdf' ? (React.createElement("div", { dangerouslySetInnerHTML: state.docHtml })) : state.url ? (React.createElement("object", { data: state.url, type: "application/pdf", width: "100%", height: "100%" },
        React.createElement("p", null,
            "Your browser does not support PDFs.",
            React.createElement("a", { href: state.url }, "Download the PDF"),
            "."))) : null;
};

var defaultProps = {
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    loaded: function () { },
    disableContent: 'none',
    googleCheckContentLoaded: true,
    googleCheckInterval: 3000,
    queryParams: '',
    url: '',
    viewer: 'google',
    viewerUrl: '',
};

export { DocumentViewer, defaultProps, fileToArray, getDocxToHtml, getLocation, getViewerDetails, getbaseUrl, googleCheckSubscription, handleFileUpload, iframeIsLoaded, isLocalFile, replaceLocalUrl, uploadToCloud };
